export const ProductTypes = [
  { value: "any", label: "Any" },
  { value: "turban", label: "Turban" },
  { value: "wig", label: "Wig" },
  { value: "braid", label: "Braid" },
];
